export const SoundOn = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="31"
        height="26"
        viewBox="0 0 31 26"
        fill="none"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.8267 4.0932C17.8267 2.50334 15.9589 1.64866 14.7558 2.68797L9.80981 6.96057C9.06774 7.60161 8.11985 7.95434 7.13924 7.95434L4.82804 7.95436C3.39226 7.95437 2.22834 9.1183 2.22834 10.5541V15.446C2.22834 16.8818 3.39227 18.0457 4.82806 18.0457H7.13928C8.1199 18.0457 9.06781 18.3985 9.80988 19.0395L14.7558 23.312C15.9589 24.3513 17.8267 23.4967 17.8267 21.9068V4.0932ZM13.2991 1.00169C15.946 -1.28479 20.055 0.595521 20.055 4.0932V21.9068C20.055 25.4045 15.946 27.2848 13.2991 24.9983L8.35319 20.7258C8.01589 20.4344 7.58502 20.2741 7.13928 20.2741H4.82806C2.16159 20.2741 0 18.1125 0 15.446V10.5541C0 7.88763 2.16158 5.72604 4.82802 5.72602L7.13923 5.72601C7.58496 5.726 8.01582 5.56567 8.35312 5.27429L13.2991 1.00169Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.7281 7.65328C23.2201 7.28363 23.9185 7.38277 24.2882 7.87471C25.361 9.30245 25.9972 11.0789 25.9972 13.0007C25.9972 14.9225 25.361 16.6989 24.2882 18.1267C23.9185 18.6186 23.2201 18.7177 22.7281 18.3481C22.2362 17.9784 22.1371 17.28 22.5067 16.7881C23.2995 15.733 23.7688 14.4232 23.7688 13.0007C23.7688 11.5782 23.2995 10.2684 22.5067 9.21331C22.1371 8.72137 22.2362 8.02292 22.7281 7.65328Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.6993 3.19667C26.1913 2.82703 26.8897 2.92617 27.2594 3.41811C29.265 6.08727 30.4539 9.4068 30.4539 13.0007C30.4539 16.5947 29.265 19.9142 27.2594 22.5834C26.8897 23.0753 26.1913 23.1745 25.6993 22.8048C25.2074 22.4352 25.1082 21.7367 25.4779 21.2448C27.2035 18.9483 28.2256 16.0954 28.2256 13.0007C28.2256 9.90609 27.2035 7.05323 25.4779 4.75671C25.1082 4.26477 25.2074 3.56632 25.6993 3.19667Z"
            fill="currentColor"
        />
    </svg>
);

export const SoundOff = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23 9.13299C23 7.52768 21.1141 6.66469 19.8993 7.7141L14.9052 12.0282C14.1559 12.6755 13.1988 13.0317 12.2087 13.0317L9.87498 13.0317C8.42524 13.0317 7.25 14.207 7.25 15.6567V20.5962C7.25 22.0459 8.42525 23.2212 9.875 23.2212H13.325V25.4712H9.875C7.18261 25.4712 5 23.2885 5 20.5962V15.6567C5 12.9643 7.18259 10.7817 9.87496 10.7817L12.2086 10.7817C12.6587 10.7817 13.0938 10.6198 13.4343 10.3256L18.4284 6.01143C21.101 3.70272 25.25 5.60131 25.25 9.13299V13.0771H23V9.13299ZM24.125 17.9521C24.7463 17.9521 25.25 18.4558 25.25 19.0771V27.1198C25.25 30.6515 21.101 32.55 18.4284 30.2413L18.0052 29.8757L15.9212 28.2048C15.4365 27.8161 15.3586 27.1081 15.7473 26.6233C16.136 26.1386 16.844 26.0607 17.3288 26.4494L19.4448 28.1461L19.8993 28.5387C21.1141 29.5881 23 28.7251 23 27.1198V19.0771C23 18.4558 23.5037 17.9521 24.125 17.9521Z"
            fill="#0F172A"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.8295 30.3726C7.26884 30.8119 7.98116 30.8119 8.4205 30.3726L30.9205 7.8726C31.3598 7.43326 31.3598 6.72095 30.9205 6.28161C30.4812 5.84227 29.7688 5.84227 29.3295 6.28161L6.8295 28.7816C6.39017 29.2209 6.39017 29.9333 6.8295 30.3726Z"
            fill="#FF8248"
        />
    </svg>
);


export const Menu = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="16"
        viewBox="0 0 20 16"
        fill="none"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 1.5C0 0.809644 0.497461 0.25 1.11111 0.25H18.8889C19.5025 0.25 20 0.809644 20 1.5C20 2.19036 19.5025 2.75 18.8889 2.75H1.11111C0.497461 2.75 0 2.19036 0 1.5Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 8C0 7.30964 0.497461 6.75 1.11111 6.75H18.8889C19.5025 6.75 20 7.30964 20 8C20 8.69036 19.5025 9.25 18.8889 9.25H1.11111C0.497461 9.25 0 8.69036 0 8Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 14.5C0 13.8096 0.497461 13.25 1.11111 13.25H18.8889C19.5025 13.25 20 13.8096 20 14.5C20 15.1904 19.5025 15.75 18.8889 15.75H1.11111C0.497461 15.75 0 15.1904 0 14.5Z"
            fill="currentColor"
        />
    </svg>
);

export const Close = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.11612 1.02603C1.60427 0.537879 2.35176 0.493909 2.78567 0.927825L15.3565 13.4986C15.7904 13.9325 15.7464 14.68 15.2583 15.1682C14.7701 15.6563 14.0226 15.7003 13.5887 15.2664L1.01791 2.69559C0.583991 2.26168 0.627961 1.51419 1.11612 1.02603Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.883883 15.026C0.395728 14.5379 0.351758 13.7904 0.785674 13.3565L13.3565 0.78569C13.7904 0.351773 14.5379 0.395743 15.026 0.883899C15.5142 1.37205 15.5581 2.11954 15.1242 2.55346L2.55344 15.1242C2.11953 15.5582 1.37204 15.5142 0.883883 15.026Z"
            fill="#FF8248"
        />
    </svg>
);

export const NextArrow = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        {...props}
    >
        <path
            d="M10.7321 15C9.96225 16.3333 8.03775 16.3333 7.26795 15L0.339749 3C-0.430052 1.66667 0.532199 2.02535e-06 2.0718 2.15994e-06L15.9282 3.37131e-06C17.4678 3.5059e-06 18.4301 1.66667 17.6603 3L10.7321 15Z"
            fill="#2B3247"
        />
    </svg>
);

export const GoArrow = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="18"
        viewBox="0 0 15 18"
        fill="none"
        {...props}
    >
        <path
            d="M14 7.26795C15.3333 8.03775 15.3333 9.96225 14 10.7321L3.5 16.7942C2.16667 17.564 0.500001 16.6018 0.500001 15.0622L0.500002 2.93782C0.500002 1.39822 2.16667 0.435971 3.5 1.20577L14 7.26795Z"
            fill="currentColor"
        />
    </svg>
);

export const Cart = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        {...props}
    >
        <g clip-path="url(#clip0_1255_481)">
            <path
                d="M22.713 4.077C22.4317 3.73944 22.0796 3.46795 21.6815 3.28182C21.2835 3.09568 20.8494 2.99946 20.41 3H4.242L4.2 2.649C4.11405 1.91942 3.76338 1.24673 3.21449 0.758478C2.6656 0.270223 1.95663 0.000341793 1.222 0L1 0C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1C0 1.26522 0.105357 1.51957 0.292893 1.70711C0.48043 1.89464 0.734784 2 1 2H1.222C1.46693 2.00003 1.70334 2.08996 1.88637 2.25272C2.06941 2.41547 2.18634 2.63975 2.215 2.883L3.591 14.583C3.73385 15.7998 4.31848 16.9218 5.23391 17.736C6.14934 18.5502 7.33185 19 8.557 19H19C19.2652 19 19.5196 18.8946 19.7071 18.7071C19.8946 18.5196 20 18.2652 20 18C20 17.7348 19.8946 17.4804 19.7071 17.2929C19.5196 17.1054 19.2652 17 19 17H8.557C7.93806 16.9983 7.3348 16.8051 6.82994 16.4471C6.32507 16.089 5.94331 15.5835 5.737 15H17.657C18.8293 15.0001 19.9643 14.5882 20.8638 13.8364C21.7633 13.0846 22.37 12.0407 22.578 10.887L23.363 6.533C23.4414 6.10101 23.4237 5.65707 23.3114 5.23264C23.1991 4.80821 22.9948 4.41368 22.713 4.077Z"
                fill="currentColor"
            />
            <path
                d="M7 24.0007C8.10456 24.0007 8.99999 23.1053 8.99999 22.0007C8.99999 20.8962 8.10456 20.0007 7 20.0007C5.89543 20.0007 5 20.8962 5 22.0007C5 23.1053 5.89543 24.0007 7 24.0007Z"
                fill="currentColor"
            />
            <path
                d="M17 24.0007C18.1046 24.0007 19 23.1053 19 22.0007C19 20.8962 18.1046 20.0007 17 20.0007C15.8954 20.0007 15 20.8962 15 22.0007C15 23.1053 15.8954 24.0007 17 24.0007Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_1255_481">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const RemoveFromCart = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        {...props}
    >
        <g clip-path="url(#clip0_1255_2646)">
            <path
                d="M12 8C11.2976 8.00082 10.6074 7.81645 9.99895 7.46547C9.39052 7.11448 8.88537 6.6093 8.53442 6.00085C8.18348 5.3924 7.99915 4.70217 8.00001 3.99977C8.00087 3.29736 8.1869 2.60759 8.53933 2H2.828L2.8 1.76533C2.74255 1.27907 2.50871 0.830769 2.14279 0.505403C1.77688 0.180036 1.30432 0.000208558 0.814667 0L0.666667 0C0.489856 0 0.320286 0.0702379 0.195262 0.195262C0.0702379 0.320286 0 0.489856 0 0.666667C0 0.843478 0.0702379 1.01305 0.195262 1.13807C0.320286 1.2631 0.489856 1.33333 0.666667 1.33333H0.814667C0.977956 1.33335 1.13556 1.3933 1.25758 1.50181C1.3796 1.61032 1.45756 1.75983 1.47667 1.922L2.394 9.722C2.48923 10.5332 2.87899 11.2812 3.48927 11.824C4.09956 12.3668 4.8879 12.6667 5.70467 12.6667H12.6667C12.8435 12.6667 13.013 12.5964 13.1381 12.4714C13.2631 12.3464 13.3333 12.1768 13.3333 12C13.3333 11.8232 13.2631 11.6536 13.1381 11.5286C13.013 11.4036 12.8435 11.3333 12.6667 11.3333H5.70467C5.29192 11.3323 4.88961 11.2036 4.5529 10.9649C4.21619 10.7262 3.96158 10.3891 3.824 10H11.7713C12.5529 10 13.3096 9.72549 13.9092 9.22429C14.5089 8.7231 14.9134 8.02713 15.052 7.258L15.2107 6.37867C14.8398 6.88144 14.3561 7.29009 13.7984 7.57171C13.2408 7.85332 12.6247 8.00002 12 8Z"
                fill="currentColor"
            />
            <path
                d="M4.66634 16.0004C5.40272 16.0004 5.99967 15.4034 5.99967 14.6671C5.99967 13.9307 5.40272 13.3337 4.66634 13.3337C3.92996 13.3337 3.33301 13.9307 3.33301 14.6671C3.33301 15.4034 3.92996 16.0004 4.66634 16.0004Z"
                fill="currentColor"
            />
            <path
                d="M11.3333 16.0004C12.0697 16.0004 12.6667 15.4034 12.6667 14.6671C12.6667 13.9307 12.0697 13.3337 11.3333 13.3337C10.597 13.3337 10 13.9307 10 14.6671C10 15.4034 10.597 16.0004 11.3333 16.0004Z"
                fill="currentColor"
            />
            <path
                d="M10.1144 3.05767L11.0572 4.00048L10.1144 4.94329C9.98936 5.06831 9.91912 5.23788 9.91912 5.41469C9.91912 5.5915 9.98936 5.76107 10.1144 5.8861C10.2394 6.01112 10.409 6.08136 10.5858 6.08136C10.7626 6.08136 10.9322 6.01112 11.0572 5.8861L12 4.94329L12.9428 5.8861C13.0678 6.01112 13.2374 6.08136 13.4142 6.08136C13.591 6.08136 13.7606 6.01112 13.8856 5.8861C14.0106 5.76107 14.0809 5.5915 14.0809 5.41469C14.0809 5.23788 14.0106 5.06831 13.8856 4.94329L12.9428 4.00048L13.8856 3.05767C14.0106 2.93265 14.0809 2.76308 14.0809 2.58627C14.0809 2.40946 14.0106 2.23989 13.8856 2.11486C13.7606 1.98984 13.591 1.9196 13.4142 1.9196C13.2374 1.9196 13.0678 1.98984 12.9428 2.11486L12 3.05767L11.0572 2.11487C10.9322 1.98984 10.7626 1.9196 10.5858 1.9196C10.409 1.9196 10.2394 1.98984 10.1144 2.11487C9.98936 2.23989 9.91912 2.40946 9.91912 2.58627C9.91912 2.76308 9.98936 2.93265 10.1144 3.05767Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_1255_2646">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const ShareLink = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        {...props}
    >
        <path
            d="M6.57212 11.4258C5.64576 12.3864 4.13714 12.4751 3.10472 11.6295C2.48986 11.0971 2.17579 10.2967 2.26456 9.48822C2.34144 8.89218 2.62002 8.34039 3.05396 7.92461L4.73195 6.24547C5.07359 5.90372 5.07359 5.34974 4.73195 5.00799C4.3902 4.66634 3.83622 4.66634 3.49447 5.00799L1.85209 6.65097C1.10344 7.3729 0.631315 8.33424 0.517735 9.36803C0.30559 11.6965 2.02116 13.756 4.34959 13.9682C5.6 14.0821 6.8365 13.6351 7.72498 12.7479L9.47999 10.9935C9.82163 10.6518 9.82163 10.0978 9.47999 9.75603C9.13824 9.41438 8.58426 9.41438 8.24251 9.75603L6.57212 11.4258Z"
            fill="currentColor"
        />
        <path
            d="M12.8449 0.85593C11.1025 -0.424162 8.68312 -0.223475 7.17554 1.32619L5.52381 2.9785C5.18217 3.32026 5.18217 3.87423 5.52381 4.21599C5.86556 4.55763 6.41954 4.55763 6.76129 4.21599L8.43928 2.53975C9.3454 1.60258 10.8115 1.49701 11.8425 2.2947C12.9037 3.16489 13.0586 4.73058 12.1884 5.7918C12.1375 5.85391 12.0836 5.9135 12.0269 5.97039L10.2718 7.72539C9.93021 8.06714 9.93021 8.62112 10.2718 8.96288C10.6136 9.30452 11.1676 9.30452 11.5093 8.96288L13.2643 7.20787C14.9166 5.55036 14.9123 2.8673 13.2548 1.21508C13.126 1.0867 12.9891 0.966748 12.8449 0.85593Z"
            fill="currentColor"
        />
        <path
            d="M5.52391 7.72678L8.24307 5.00762C8.58485 4.66584 9.13897 4.66584 9.48075 5.00762C9.82253 5.3494 9.82253 5.90351 9.48075 6.24529L6.76159 8.96446C6.41981 9.30624 5.86569 9.30624 5.52391 8.96446C5.18213 8.62268 5.18213 8.06856 5.52391 7.72678Z"
            fill="currentColor"
        />
    </svg>
);

export const Download = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        {...props}
    >
        <path
            d="M5.66224 10.325C6.68736 11.3501 8.34942 11.3501 9.37456 10.325L9.37459 10.325L11.2483 8.45132C11.5959 8.1156 11.6055 7.56167 11.2698 7.21408C10.934 6.86648 10.3801 6.85686 10.0325 7.19258C10.0252 7.19961 10.018 7.2068 10.011 7.21408L8.38759 8.8369L8.37416 0.875C8.37416 0.391754 7.98241 0 7.49916 0C7.01592 0 6.62416 0.391754 6.62416 0.875L6.63641 8.82408L5.02584 7.2135C4.67825 6.87777 4.12432 6.8874 3.78859 7.23499C3.46109 7.57408 3.46109 8.11166 3.78859 8.45075L5.66224 10.325Z"
            fill="currentColor"
        />
        <path
            d="M13.625 8.45833C13.1418 8.45833 12.75 8.85008 12.75 9.33333V12.0114C12.7497 12.143 12.6431 12.2497 12.5114 12.25H2.48857C2.35694 12.2496 2.2503 12.143 2.25 12.0114V9.33333C2.25 8.85008 1.85825 8.45833 1.375 8.45833C0.891754 8.45833 0.5 8.85008 0.5 9.33333V12.0114C0.501285 13.1091 1.39086 13.9987 2.48857 14H12.5114C13.6091 13.9987 14.4987 13.1091 14.5 12.0114V9.33336C14.5 8.85008 14.1082 8.45833 13.625 8.45833Z"
            fill="currentColor"
        />
    </svg>
);

export const RatingStar = (props) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M7.06215 1.53451C7.38431 0.663888 8.61569 0.663888 8.93785 1.53451L10.2712 5.13794C10.3725 5.41166 10.5883 5.62747 10.8621 5.72876L14.4655 7.06215C15.3361 7.38431 15.3361 8.61569 14.4655 8.93785L10.8621 10.2712C10.5883 10.3725 10.3725 10.5883 10.2712 10.8621L8.93785 14.4655C8.61569 15.3361 7.38431 15.3361 7.06215 14.4655L5.72876 10.8621C5.62747 10.5883 5.41166 10.3725 5.13794 10.2712L1.53451 8.93785C0.663888 8.61569 0.663888 7.38431 1.53451 7.06215L5.13794 5.72876C5.41166 5.62747 5.62747 5.41166 5.72876 5.13794L7.06215 1.53451Z"
            fill="#FFDF5A"
        />
    </svg>
);

export const CopyLink = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        {...props}
    >
        <path
            d="M6.93957 13.0582C5.88087 14.156 4.15673 14.2573 2.97682 13.2909C2.27413 12.6825 1.91519 11.7677 2.01664 10.8438C2.1045 10.1626 2.42288 9.53196 2.91881 9.05678L4.83652 7.13777C5.22696 6.74719 5.22696 6.11407 4.83652 5.7235C4.44594 5.33305 3.81282 5.33305 3.42225 5.7235L1.54524 7.6012C0.689644 8.42626 0.150075 9.52493 0.0202691 10.7064C-0.222183 13.3675 1.73847 15.7213 4.39953 15.9637C5.82858 16.0939 7.24172 15.583 8.25712 14.5691L10.2628 12.5641C10.6533 12.1735 10.6533 11.5404 10.2628 11.1498C9.87227 10.7594 9.23915 10.7594 8.84858 11.1498L6.93957 13.0582Z"
            fill="#374957"
        />
        <path
            d="M14.107 0.978258C12.1158 -0.484704 9.35075 -0.255348 7.6278 1.5157L5.7401 3.40406C5.34965 3.79463 5.34965 4.42775 5.7401 4.81832C6.13067 5.20877 6.76379 5.20877 7.15437 4.81832L9.07207 2.90262C10.1076 1.83157 11.7831 1.71093 12.9615 2.62257C14.1743 3.61707 14.3513 5.40643 13.3568 6.61925C13.2986 6.69024 13.237 6.75834 13.1722 6.82335L11.1664 8.82907C10.776 9.21965 10.776 9.85277 11.1664 10.2433C11.557 10.6338 12.1901 10.6338 12.5807 10.2433L14.5864 8.23762C16.4747 6.34333 16.4698 3.27697 14.5755 1.38871C14.4283 1.242 14.2718 1.10491 14.107 0.978258Z"
            fill="#374957"
        />
        <path
            d="M5.74022 8.83063L8.84783 5.72301C9.23844 5.3324 9.87171 5.3324 10.2623 5.72301C10.6529 6.11361 10.6529 6.74689 10.2623 7.13749L7.1547 10.2451C6.7641 10.6357 6.13082 10.6357 5.74022 10.2451C5.34961 9.85451 5.34961 9.22123 5.74022 8.83063Z"
            fill="#374957"
        />
    </svg>
);

export const Facebook = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        {...props}
    >
        <g clip-path="url(#clip0_1625_2446)">
            <mask
                id="mask0_1625_2446"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="18"
                height="18"
            >
                <path d="M0 0H18V18H0V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_1625_2446)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 9.05025C0 13.5255 3.24975 17.2455 7.5 18V11.4998H5.25V9H7.5V6.99975C7.5 4.74975 8.94975 3.50025 11.0002 3.50025C11.6497 3.50025 12.3503 3.6 12.9998 3.69975V6H11.85C10.7498 6 10.5 6.54975 10.5 7.25025V9H12.9L12.5002 11.4998H10.5V18C14.7502 17.2455 18 13.5255 18 9.05025C18 4.0725 13.95 0 9 0C4.05 0 0 4.0725 0 9.05025Z"
                    fill="#334155"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_1625_2446">
                <rect width="18" height="18" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const Line = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        {...props}
    >
        <path
            d="M18.6649 10.84C18.6646 10.9794 18.6091 11.1129 18.5105 11.2113C18.4119 11.3097 18.2782 11.365 18.1389 11.365H16.6769V12.303H18.1399C18.2107 12.2999 18.2814 12.3112 18.3477 12.3362C18.4141 12.3611 18.4747 12.3993 18.5259 12.4483C18.5771 12.4973 18.6178 12.5562 18.6456 12.6213C18.6735 12.6865 18.6878 12.7566 18.6878 12.8275C18.6878 12.8984 18.6735 12.9685 18.6456 13.0337C18.6178 13.0989 18.5771 13.1578 18.5259 13.2068C18.4747 13.2558 18.4141 13.2939 18.3477 13.3189C18.2814 13.3438 18.2107 13.3551 18.1399 13.352H16.1509C16.0124 13.351 15.88 13.2954 15.7823 13.1973C15.6845 13.0992 15.6294 12.9665 15.6289 12.828V8.85202C15.6289 8.56502 15.8639 8.32702 16.1539 8.32702H18.1419C18.2755 8.33552 18.4009 8.39467 18.4924 8.49239C18.5839 8.59012 18.6348 8.71907 18.6345 8.85296C18.6342 8.98686 18.5829 9.11561 18.491 9.21299C18.3991 9.31036 18.2736 9.36903 18.1399 9.37702H16.6769V10.315H18.1399C18.4299 10.315 18.6649 10.552 18.6649 10.84ZM14.5659 13.325C14.5124 13.3427 14.4563 13.3511 14.3999 13.35C14.3177 13.3514 14.2363 13.3333 14.1624 13.2972C14.0885 13.261 14.0242 13.2078 13.9749 13.142L11.9389 10.378V12.828C11.9289 12.96 11.8694 13.0834 11.7723 13.1734C11.6753 13.2634 11.5478 13.3134 11.4154 13.3134C11.283 13.3134 11.1555 13.2634 11.0585 13.1734C10.9614 13.0834 10.9019 12.96 10.8919 12.828V8.85202C10.8915 8.78348 10.9047 8.71554 10.9306 8.6521C10.9566 8.58867 10.9948 8.53099 11.0431 8.48239C11.0915 8.43378 11.1489 8.39521 11.2122 8.36889C11.2755 8.34257 11.3434 8.32902 11.4119 8.32902C11.5739 8.32902 11.7239 8.41502 11.8239 8.54002L13.8759 11.315V8.85202C13.8759 8.56502 14.1109 8.32702 14.4009 8.32702C14.6879 8.32702 14.9259 8.56502 14.9259 8.85202V12.828C14.9264 12.9383 14.8918 13.0459 14.827 13.1353C14.7623 13.2246 14.6709 13.2911 14.5659 13.325ZM9.61591 13.352C9.47727 13.3512 9.34455 13.2957 9.24661 13.1976C9.14867 13.0995 9.09343 12.9667 9.09291 12.828V8.85202C9.09291 8.56502 9.32791 8.32702 9.61791 8.32702C9.90691 8.32702 10.1419 8.56502 10.1419 8.85202V12.828C10.1411 12.9671 10.0854 13.1002 9.98685 13.1984C9.88832 13.2965 9.75498 13.3518 9.61591 13.352ZM8.08591 13.352H6.09991C5.96124 13.3507 5.82861 13.2951 5.73046 13.1972C5.63232 13.0992 5.57647 12.9667 5.57491 12.828V8.85202C5.57491 8.56502 5.81291 8.32702 6.09991 8.32702C6.38991 8.32702 6.62491 8.56502 6.62491 8.85202V12.302H8.08891C8.22814 12.302 8.36168 12.3573 8.46014 12.4558C8.55859 12.5542 8.61391 12.6878 8.61391 12.827C8.61391 12.9663 8.55859 13.0998 8.46014 13.1983C8.36168 13.2967 8.22814 13.352 8.08891 13.352M12.0039 2.57202C6.49091 2.57202 2.00391 6.21502 2.00391 10.69C2.00391 14.7 5.56191 18.059 10.3669 18.697C10.6919 18.765 11.1359 18.912 11.2479 19.189C11.3479 19.439 11.3139 19.827 11.2799 20.089L11.1429 20.939C11.1059 21.189 10.9429 21.927 12.0169 21.476C13.0929 21.027 17.7809 18.078 19.8809 15.664C21.3149 14.089 22.0009 12.477 22.0009 10.69C22.0009 6.21502 17.5129 2.57202 12.0009 2.57202"
            fill="#334155"
        />
    </svg>
);

export const Share = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        {...props}
    >
        <g clip-path="url(#clip0_1625_6067)">
            <path
                d="M11.5833 8.16636C11.1573 8.16794 10.7368 8.26342 10.3519 8.44602C9.96691 8.62861 9.62694 8.89382 9.35617 9.22277L6.20617 7.80061C6.2863 7.54101 6.32911 7.27134 6.33333 6.99969C6.32955 6.73099 6.28812 6.46414 6.21025 6.20694L9.35675 4.77777C9.79824 5.29735 10.4087 5.64479 11.0808 5.75906C11.753 5.87334 12.444 5.74716 13.0323 5.40267C13.6207 5.05818 14.069 4.51741 14.2983 3.87532C14.5276 3.23323 14.5234 2.53087 14.2864 1.89157C14.0494 1.25227 13.5948 0.716908 13.0023 0.379488C12.4098 0.0420672 11.7174 -0.0758373 11.0466 0.046478C10.3759 0.168793 9.76967 0.523509 9.33443 1.04834C8.89919 1.57316 8.66277 2.23455 8.66667 2.91636C8.66667 2.99919 8.68417 3.07736 8.69117 3.15844L5.225 4.73169C4.714 4.31528 4.07584 4.08636 3.41667 4.08302C2.64312 4.08302 1.90125 4.39031 1.35427 4.9373C0.807291 5.48428 0.5 6.22614 0.5 6.99969C0.5 7.77324 0.807291 8.5151 1.35427 9.06209C1.90125 9.60907 2.64312 9.91636 3.41667 9.91636C4.07299 9.91367 4.70879 9.68733 5.21917 9.27469L8.69117 10.8421C8.68417 10.9232 8.66667 11.0008 8.66667 11.083C8.66667 11.6599 8.83773 12.2238 9.15822 12.7034C9.4787 13.1831 9.93422 13.5569 10.4672 13.7777C11.0001 13.9984 11.5866 14.0562 12.1523 13.9436C12.7181 13.8311 13.2378 13.5533 13.6457 13.1454C14.0536 12.7375 14.3314 12.2178 14.444 11.652C14.5565 11.0863 14.4987 10.4998 14.278 9.96686C14.0572 9.43391 13.6834 8.97839 13.2037 8.6579C12.7241 8.33742 12.1602 8.16636 11.5833 8.16636V8.16636ZM11.5833 1.74969C11.8141 1.74969 12.0396 1.81811 12.2315 1.94631C12.4234 2.0745 12.5729 2.25671 12.6612 2.46989C12.7495 2.68307 12.7726 2.91765 12.7276 3.14396C12.6826 3.37027 12.5715 3.57815 12.4083 3.74131C12.2451 3.90448 12.0373 4.01559 11.8109 4.06061C11.5846 4.10562 11.3501 4.08252 11.1369 3.99422C10.9237 3.90591 10.7415 3.75638 10.6133 3.56452C10.4851 3.37266 10.4167 3.1471 10.4167 2.91636C10.4167 2.60694 10.5396 2.31019 10.7584 2.0914C10.9772 1.87261 11.2739 1.74969 11.5833 1.74969V1.74969ZM3.41667 8.16636C3.18592 8.16636 2.96036 8.09793 2.7685 7.96974C2.57664 7.84154 2.42711 7.65933 2.33881 7.44615C2.25051 7.23297 2.2274 6.9984 2.27242 6.77208C2.31743 6.54577 2.42855 6.33789 2.59171 6.17473C2.75487 6.01157 2.96275 5.90046 3.18906 5.85544C3.41537 5.81042 3.64995 5.83353 3.86313 5.92183C4.07631 6.01013 4.25852 6.15967 4.38672 6.35153C4.51491 6.54338 4.58333 6.76895 4.58333 6.99969C4.58333 7.30911 4.46042 7.60586 4.24163 7.82465C4.02283 8.04344 3.72609 8.16636 3.41667 8.16636ZM11.5833 12.2497C11.3526 12.2497 11.127 12.1813 10.9352 12.0531C10.7433 11.9249 10.5938 11.7427 10.5055 11.5295C10.4172 11.3163 10.3941 11.0817 10.4391 10.8554C10.4841 10.6291 10.5952 10.4212 10.7584 10.2581C10.9215 10.0949 11.1294 9.98379 11.3557 9.93877C11.582 9.89376 11.8166 9.91686 12.0298 10.0052C12.243 10.0935 12.4252 10.243 12.5534 10.4349C12.6816 10.6267 12.75 10.8523 12.75 11.083C12.75 11.3924 12.6271 11.6892 12.4083 11.908C12.1895 12.1268 11.8928 12.2497 11.5833 12.2497Z"
                fill="#334155"
            />
        </g>
        <defs>
            <clipPath id="clip0_1625_6067">
                <rect
                    width="14"
                    height="14"
                    fill="white"
                    transform="translate(0.5)"
                />
            </clipPath>
        </defs>
    </svg>
);

export const VideoPlay = (props) => (
    <svg
        width="75"
        height="75"
        viewBox="0 0 75 75"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M0 37.5C0 16.7893 16.7893 0 37.5 0C58.2107 0 75 16.7893 75 37.5C75 58.2107 58.2107 75 37.5 75C16.7893 75 0 58.2107 0 37.5Z"
            fill="#FFDF5A"
        />
        <path
            d="M56 32.3038C60 34.6132 60 40.3868 56 42.6962L32.75 56.1195C28.75 58.4289 23.75 55.5422 23.75 50.9234L23.75 24.0766C23.75 19.4578 28.75 16.5711 32.75 18.8805L56 32.3038Z"
            fill="#334155"
        />
    </svg>
);

export const SliderNextArrow = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="34"
        viewBox="0 0 30 34"
        fill="none"
        {...props}
    >
        <path
            d="M27 11.8039C31 14.1133 31 19.8868 27 22.1962L9 32.5885C5 34.8979 4.65203e-07 32.0111 4.10124e-07 27.3923L1.6227e-07 6.6077C1.07191e-07 1.98889 5 -0.897856 9 1.41155L27 11.8039Z"
            fill="currentColor"
        />
    </svg>
);


export const SliderPrevArrow = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30" 
        height="34"
        viewBox="0 0 30 34"
        fill="none"
        style={{ transform: 'rotate(180deg)' }}
        {...props}
    >
        <path
            d="M27 11.8039C31 14.1133 31 19.8868 27 22.1962L9 32.5885C5 34.8979 4.65203e-07 32.0111 4.10124e-07 27.3923L1.6227e-07 6.6077C1.07191e-07 1.98889 5 -0.897856 9 1.41155L27 11.8039Z"
            fill="currentColor"
        />
    </svg>
);

export const QuestionMark = props => (
    <svg height="800px" width="800px" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" 
	 viewBox="0 0 512 512"  xmlSpace="preserve" {...props}>
    <g>
        <path stroke="currentColor" d="M396.138,85.295c-13.172-25.037-33.795-45.898-59.342-61.03C311.26,9.2,280.435,0.001,246.98,0.001
            c-41.238-0.102-75.5,10.642-101.359,25.521c-25.962,14.826-37.156,32.088-37.156,32.088c-4.363,3.786-6.824,9.294-6.721,15.056
            c0.118,5.77,2.775,11.186,7.273,14.784l35.933,28.78c7.324,5.864,17.806,5.644,24.875-0.518c0,0,4.414-7.978,18.247-15.88
            c13.91-7.85,31.945-14.173,58.908-14.258c23.517-0.051,44.022,8.725,58.016,20.717c6.952,5.941,12.145,12.594,15.328,18.68
            c3.208,6.136,4.379,11.5,4.363,15.574c-0.068,13.766-2.742,22.77-6.603,30.442c-2.945,5.729-6.789,10.813-11.738,15.744
            c-7.384,7.384-17.398,14.207-28.634,20.479c-11.245,6.348-23.365,11.932-35.612,18.68c-13.978,7.74-28.77,18.858-39.701,35.544
            c-5.449,8.249-9.71,17.686-12.416,27.641c-2.742,9.964-3.98,20.412-3.98,31.071c0,11.372,0,20.708,0,20.708
            c0,10.719,8.69,19.41,19.41,19.41h46.762c10.719,0,19.41-8.691,19.41-19.41c0,0,0-9.336,0-20.708c0-4.107,0.467-6.755,0.917-8.436
            c0.773-2.512,1.206-3.14,2.47-4.668c1.29-1.452,3.895-3.674,8.698-6.331c7.019-3.946,18.298-9.276,31.07-16.176
            c19.121-10.456,42.367-24.646,61.972-48.062c9.752-11.686,18.374-25.758,24.323-41.968c6.001-16.21,9.242-34.431,9.226-53.96
            C410.243,120.761,404.879,101.971,396.138,85.295z"/>
        <path stroke="currentColor" d="M228.809,406.44c-29.152,0-52.788,23.644-52.788,52.788c0,29.136,23.637,52.772,52.788,52.772
            c29.136,0,52.763-23.636,52.763-52.772C281.572,430.084,257.945,406.44,228.809,406.44z"/>
    </g>
</svg>
)

export const ScrollDown = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        {...props}
    >
        <path
            d="M4.68737 13.4136C4.68724 13.1168 4.77514 12.8267 4.93995 12.5799C5.10476 12.3331 5.33908 12.1407 5.61326 12.0271C5.88743 11.9135 6.18913 11.8838 6.4802 11.9418C6.77126 11.9997 7.03859 12.1427 7.24837 12.3526L11.8334 16.9386C11.8798 16.9851 11.935 17.0221 11.9957 17.0473C12.0565 17.0725 12.1216 17.0855 12.1874 17.0855C12.2531 17.0855 12.3183 17.0725 12.379 17.0473C12.4398 17.0221 12.4949 16.9851 12.5414 16.9386L17.1264 12.3566C17.4076 12.0752 17.7892 11.917 18.187 11.917C18.5849 11.9169 18.9665 12.0748 19.2479 12.3561C19.5293 12.6373 19.6874 13.0189 19.6875 13.4167C19.6876 13.8146 19.5296 14.1962 19.2484 14.4776L14.6624 19.0636C14.0053 19.7188 13.1153 20.0868 12.1874 20.0868C11.2595 20.0868 10.3694 19.7188 9.71237 19.0636L5.12637 14.4776C4.98675 14.3379 4.87609 14.172 4.80076 13.9894C4.72542 13.8068 4.68689 13.6111 4.68737 13.4136V13.4136Z"
            fill="white"
        />
        <path
            d="M4.68737 6.41358C4.68724 6.11681 4.77514 5.82667 4.93995 5.57987C5.10476 5.33307 5.33908 5.14071 5.61326 5.02712C5.88743 4.91353 6.18913 4.88383 6.4802 4.94176C6.77126 4.9997 7.03859 5.14267 7.24837 5.35258L12.1874 10.2956L17.1264 5.35658C17.4076 5.07519 17.7892 4.91705 18.187 4.91696C18.5849 4.91686 18.9665 5.07482 19.2479 5.35608C19.5293 5.63735 19.6874 6.01887 19.6875 6.41673C19.6876 6.81459 19.5296 7.19619 19.2484 7.47758L13.2484 13.4776C13.1091 13.617 12.9437 13.7275 12.7616 13.803C12.5796 13.8784 12.3844 13.9173 12.1874 13.9173C11.9903 13.9173 11.7952 13.8784 11.6131 13.803C11.4311 13.7275 11.2657 13.617 11.1264 13.4776L5.12637 7.47758C4.98675 7.33787 4.87609 7.17196 4.80076 6.98937C4.72542 6.80678 4.68689 6.6111 4.68737 6.41358V6.41358Z"
            fill="white"
        />
    </svg>
);

export const ClickHint = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        {...props}
    >
        <path
            d="M23.6383 19.5179C23.6167 19.5462 24.0705 19.9814 24.126 20.0353C25.2189 21.0873 26.6219 22.1663 27.6228 23.2604C28.0517 23.7291 28.1353 24.5019 27.7645 25.0332C27.4517 25.4802 25.5603 27.3708 25.1053 27.723C24.645 28.0798 23.9784 28.089 23.4946 27.7678L19.4592 23.706C19.3619 23.6863 19.3998 23.7271 19.3756 23.7686C19.3103 23.8818 19.2457 24.0016 19.1824 24.1162C18.8037 24.8021 18.4466 25.6638 18.0274 26.3024C17.5756 26.991 16.8666 27.251 16.1269 26.8198C15.6444 26.5387 15.5804 26.2326 15.4518 25.727C14.5339 22.1162 13.9868 18.3316 13.0871 14.7077C13.0172 13.9131 13.7987 13.2041 14.5665 13.2653C18.1711 14.1165 21.916 14.6557 25.5048 15.5417C26.1133 15.6918 26.5514 15.8189 26.7688 16.4844C27.0613 17.3804 26.5625 17.8702 25.8705 18.2941C25.1503 18.7352 24.3793 19.1137 23.6383 19.5179Z"
            fill="#2B3247"
        />
        <path
            d="M20.7911 6.6678C21.9473 6.46833 22.5193 7.58153 21.8063 8.48011C21.1985 9.24638 20.3034 9.94682 19.6753 10.717C18.619 11.5109 17.3119 10.1542 18.2612 8.99557C18.5361 8.65983 20.2943 6.87451 20.575 6.74614C20.6422 6.7152 20.7186 6.68031 20.7904 6.6678H20.7911Z"
            fill="#2B3247"
        />
        <path
            d="M9.74763 17.9538C10.6793 17.8254 11.3067 18.6786 10.8745 19.5331C10.7354 19.8089 8.86428 21.6956 8.55351 21.9234C7.55853 22.6528 6.41925 21.6403 6.93372 20.5857C7.07801 20.2901 8.83099 18.5449 9.17244 18.2599C9.35525 18.1072 9.5041 17.9867 9.74763 17.9531V17.9538Z"
            fill="#2B3247"
        />
        <path
            d="M7.59573 6.6678C7.86537 6.62369 8.09779 6.69677 8.31716 6.85344C9.00987 7.65921 10.1583 8.41757 10.7844 9.24441C11.5254 10.224 10.2033 11.2687 9.28538 10.7065C9.00725 10.536 7.14459 8.65917 6.92457 8.35635C6.47017 7.7303 6.86451 6.78761 7.59573 6.66846V6.6678Z"
            fill="#2B3247"
        />
        <path
            d="M14.2936 4.00627C14.9459 3.93452 15.3774 4.43614 15.4303 5.05232C15.4832 5.66849 15.5139 7.64275 15.397 8.22535C15.1633 9.38923 13.5285 9.2997 13.4227 8.11146C13.33 7.06936 13.486 5.87717 13.4364 4.81994C13.5291 4.41771 13.8764 4.05301 14.2936 4.00693V4.00627Z"
            fill="#2B3247"
        />
        <path
            d="M4.7616 13.4187L8.24666 13.4286C9.32783 13.7874 9.23773 15.2804 8.06777 15.4213C7.36462 15.5062 5.76246 15.4911 5.04168 15.4285C3.79468 15.3199 3.62493 13.8209 4.76225 13.4181L4.7616 13.4187Z"
            fill="#2B3247"
        />
    </svg>
);